import { Badge, Button, ButtonGroup, DialogBody, DialogFooter, FormatNumber, Stack, Text } from "@chakra-ui/react"
import { UI } from "components"
import { API } from "config"
import { toaster } from "config"
import useWithdrawals from "hooks/useWithrawals"
import moment from "moment"
import { useState } from "react"
import useOptions from "hooks/useOptions";

export default function Cancel({ data, ...props }){
    const [ loading, setLoading ] = useState(false)
    const withdrawals = useWithdrawals()
    const options = useOptions();
    
    const handleDelete = async () => {
        if(!window.confirm('Tem certeza que deseja cancelar o pedido de saque?')) return
        setLoading(true)

        try{
            await API.put(`/withdrawals/${data?.id}/cancel`)
            withdrawals.refetch()
            props?.onClose()
        }catch(err){
            toaster.create({
                title: 'Não foi possível cancelar o pedido de saque.',
                description: err?.response?.data?.message,
                type: 'warning'
            });
            props?.onClose()
        } finally {
            setLoading(false)
        }
    }
    return(
    <UI.Dialog size="sm" title="Cancelar pedido de saque" loading={loading} {...props}>
        <DialogBody>
            <Stack gap={4}>
                <Text>
                    Você está prestes a cancelar o  pedido de saque no valor de <b><FormatNumber value={data?.total / 100} style="currency" currency="BRL" /></b> 
                    solicitado por você no dia <b>{moment(data?.created_at).format('LLL')}</b>.
                </Text>
                <Text>
                Apenas solicitações com o status <Badge children="Aguardando" colorPalette="yellow" /> ou <Badge children="Aprovado" colorPalette="teal" /> podem ser cancelados por você.
                </Text>

                <UI.Alert size="sm">
                    Você poderá realizar um novo pedido de saque desde que esteja nas datas disponíveis (dias{" "}
                    <b>{options.data?.rawDays || "--"}</b> de cada mês).
                </UI.Alert>
            </Stack>
        </DialogBody>
        <DialogFooter>
            <ButtonGroup size="xs">
                <Button colorPalette="red" loading={loading} onClick={handleDelete}><UI.Icon name="cancel" /> Cancelar pedido de saque</Button>
            </ButtonGroup>
        </DialogFooter>
    </UI.Dialog>
    )
}